const languageLevelsExplanation = [
  {
    level: 'C2',
    title: 'Fluent',
    description: 
      `You speak like a native: effortlessly, precisely, and with full command of jokes, sarcasm, and complex ideas. 
      You could give a TED Talk or argue about pineapple on pizza. `
  },
  {
    level: 'C1',
    title: 'Advanced', 
    description:
      `You handle nearly any topic with ease, from deep discussions to dry humor.
      You're not just fluent, you think in the language.
      At this point, people stop complimenting your skills because they sometimes forget you're not a native.`
  },
  {
    level: 'B2',
    title: 'Upper Intermediate',
    description:
      `You chat comfortably, follow fast conversations, and express opinions clearly.
      Mistakes happen, but you recover like a pro.
      You may not pass as a local yet, but you're definitely the cool tourist who gets invited to dinner.`
  },
  {
    level: 'B1',
    title: 'Intermediate',
    description:
      `You hold everyday conversations, explain ideas, and get by in most situations.
      You still pause now and then, but you're in the game.`
  },
  {
    level: 'A2',
    title: 'Pre-Intermediate',
    description:
      `You manage basic conversations, daily routines, and simple questions.
      You get the gist, especially with slow speech and gestures.
      You nod a lot, sometimes on purpose, sometimes out of sheer survival.`
  },
  {
    level: 'A1',
    title: 'Basic',
    description:
      `You can say who you are, ask simple things, and survive in a bakery.
      If people speak slowly, you might catch a word or two.
      You proudly say "bonjour," then run away before they reply.`
  },
];

export default languageLevelsExplanation;